import { http } from "../http";
import axios from "axios";

export const getNotificationsSnapshot = async () => {
  try {
    const response = await http.get(`/notifications/get_notifications`);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getAllNotifications = async (hideArchivedNotifications) => {
  try {
    const url = hideArchivedNotifications == null ?
      `/notifications/get_Allnotifications` :
      `/notifications/get_Allnotifications?includeArchived=${!hideArchivedNotifications}`
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const markNotificationsAsRead = async (notificationId) => {
  try {
    const url = notificationId
      ? `/notifications/mark_notification_as_read/${notificationId}`
      : `/notifications/mark_notifications_as_read`;
    await http.get(url);
  } catch (ex) {
    console.log(ex);
  }
};

export const archiveNotification = async (notificationId) => {
  try {
    const formData = new FormData();
    formData.append("id", notificationId);
    const response = await axios.post('/notifications/archive_notification', formData);
    return response;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
}

export const getArchivedNotifications = async () => {
  try {
    const response = await http.get('/notifications/get_archived_notifications');
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
}